/* global axios */
import ApiClient from './ApiClient';

class ConnectedApplicationsAPI extends ApiClient {
  constructor() {
    super('profile/connected_applications', { accountScoped: false });
  }

  get() {
    return axios.get(this.url);
  }

  revoke(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ConnectedApplicationsAPI();
